<template>
	<div class="product-categories">
		<div class="product-categories__title page-subtitle">{{ title }}</div>
		<div class="product-categories__search">
			<InputSearch v-model="searchQuery" actionBtn/>
		</div>
		<div class="product-categories__content" :class="{'product-categories__content--card' : tagsBlock}">
			<div class="product-categories__tags" v-if="tagsBlock && this.disabledProductsTags.size">
				<div class="tags-item" v-for="tag in this.disabledProductsTags" :key="tag">
					<div class="tags-item__title">{{tag.name}}</div>
					<div class="tags-item__delete" @click="deleteDisabledProducts(tag.id)"></div>
				</div>
			</div>
			<div class="product-categories__block" v-if="filteredCategories?.length" :class="{'product-categories__block--nocard' : tagsBlock}">
				<div class="categories-item ci-main" v-for="(checkbox) in filteredCategories" :key="checkbox.id">
					<div class="categories-item__checkbox">
						<div class="categories-item__arrow" v-if="checkbox.children" @click="openList"></div>
						<InputCheckbox
							:label="checkbox.name"
							:id="`${prefix}${checkbox.id}`"
							@change="checkbox.children ? selectAll($event) : fillSelectedProducts($event)"
							:showToggle="showProducts"
						/>
					</div>
					<div class="categories-nested cs-2">
						<div class="categories-item" v-for="(checkbox,index) in checkbox.children" :key="index">
							<div class="categories-item__checkbox">
								<div class="categories-item__arrow" v-if="showProducts" @click="loadProducts(checkbox.id, $event)"></div>
								<InputCheckbox
									:label="checkbox.name"
									:id="`${prefix}${checkbox.id}`"
									@change="showProducts ? selectAll($event) : fillSelectedProducts($event)"
									:showToggle="showProducts"
								/>
							</div>
							<div class="categories-nested cs-3" v-if="checkbox.products && showProducts">
								<div class="categories-item" v-for="(checkbox,index) in checkbox.products" :key="index">
									<div class="categories-item__checkbox">
										<InputCheckbox
											:label="checkbox.name"
											:id="`${prefix}${checkbox.id}`"
											@change="fillSelectedProducts($event, checkbox.name)"
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="product-categories__empty" v-else>Товарные категории не найдены</div>
			<PageLoader v-if="isLoading" :type="'absolute'"/>
		</div>
	</div>
</template>

<script>
import {defineAsyncComponent} from "vue";
import {mapActions, mapGetters} from "vuex";
import InputSearch from "@/components/base/utils/formElements/InputSearch.vue";
import PageLoader from "@/components/base/utils/PageLoader.vue";

export default {
	name: "ProductCategorieas",
	components: {
		InputSearch,
		InputCheckbox: defineAsyncComponent({
			loader: () => import('@/components/base/utils/formElements/InputCheckbox.vue')
		}),
		PageLoader
	},
	emits: ['update:modelValue'],
	props: {
		title: {
			type: String,
			default: 'Товарные категории'
		},
		prefix: {
			type: String,
			default: ''
		},
		showProducts: {
			type: Boolean,
			default: false
		},
		checkedProductGroups: {
			type: Array,
			default: () => []
		},
		supplierId: {
			type: Number
		},
		tagsBlock: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			isLoading: false,
			searchQuery: '',
			selectedProducts: new Set(),
			disabledProductsTags: new Set()
		}
	},
	async created() {
		await this.requestProductGroupsSupplier(this.supplierId);
	},
	mounted() {
		if(this.checkedProductGroups.length && !this.tagsBlock) {
			this.checkedProductGroups?.forEach(item => {
				const input = document.querySelector(`.default-checkbox__input[id='${this.prefix}${item.id || item}']`)
				if(!input) return
				const parentGroup = input.closest('.ci-main')

				input.checked = true
				setTimeout(() => input.dispatchEvent(new Event('change', {bubbles: true})),100)
				parentGroup.classList.add('ci-main--selected')
			})
		} else {
			this.checkedProductGroups.forEach(item => {
				this.selectedProducts.add(item.id)
				this.disabledProductsTags.add({
					name: item.name,
					id: item.id
				})
			})
			this.$emit('update:modelValue', Array.from(this.selectedProducts))
		}
	},
	methods: {
		openList(e) {
			const nestedList = e.target.closest('.categories-item')
			nestedList.classList.toggle('active')
		},
		selectAll(e) {
			const parentEl = e.target.closest('.categories-item')
			const checked = parentEl.querySelector('.default-checkbox__input').checked
			const checkboxes = parentEl.querySelectorAll('.categories-nested .default-checkbox__input')

			checkboxes.forEach(item => {
				item.checked = checked
				item.dispatchEvent(new Event('change', {bubbles: true}));
			})
		},
		fillSelectedProducts(e,name) {
			if (e.target.checked) {
				this.selectedProducts.add(e.target.id.replace(/[a-zа-яё]/gi, ''))

				this.disabledProductsTags.add({
					name,
					id: e.target.id
				})
			} else {
				this.selectedProducts.delete(e.target.id.replace(/[a-zа-яё]/gi, ''))

				this.deleteSetDisabledProducts(e.target.id)

				const parentCheckbox = e.target.closest('.categories-item.active')?.querySelector('.categories-item__checkbox input')
				if(parentCheckbox && parentCheckbox.checked) {
					parentCheckbox.checked = false
				}
			}

			this.$emit('update:modelValue', Array.from(this.selectedProducts))
		},
		deleteDisabledProducts(id) {
			this.selectedProducts.delete(id)
			this.deleteSetDisabledProducts(id)
			this.$emit('update:modelValue', Array.from(this.selectedProducts))

			const checkbox = document.querySelector(`.default-checkbox__input[id='${id}']`)
			if(!checkbox) return
			checkbox.checked = false
		},

		deleteSetDisabledProducts(id) {
			const arrayDisabled = [...this.disabledProductsTags].filter(obj => obj.id !== id)
			this.disabledProductsTags.clear()
			arrayDisabled.forEach(item => this.disabledProductsTags.add(item))
		},


		async loadProducts(id,e) {
			const nestedList = e.target.closest('.categories-item')
			nestedList.classList.toggle('active')
			if(nestedList.classList.contains('active')) {
				this.isLoading = true
				await this.requestProductsSupplier(id)
				this.isLoading = false
			}
		},

		...mapActions({
			requestProductGroupsSupplier: 'products/requestProductGroupsSupplier',
			requestProductsSupplier: 'products/requestProductsSupplier',
		})
	},
	computed: {
		filteredCategories() {
			if (this.searchQuery) {
				return this.list.filter(data => {
					if (data.name.toLowerCase().includes(this.searchQuery.toLowerCase())) {
						return true;
					} else if (data.children) {
						const matchingChildren = data.children.filter(child => {
							return child.name.toLowerCase().includes(this.searchQuery.toLowerCase());
						});
						if (matchingChildren.length > 0) {
							return true;
						}
					}
				});
			}
			return this.list
		},
		...mapGetters({
			list: 'products/getProductGroupsSupplier',
		})
	},

}
</script>
